var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgThree(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 43,
    viewBox: "0 0 37 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.2083 30.2915V20.1082C31.2292 20.304 30.25 20.4998 29.2708 20.4998H28.2917V32.2498H8.70833V18.5415C8.70833 13.0582 13.0167 8.74984 18.5 8.74984C18.6958 6.204 19.8708 4.04984 21.4375 2.28734C20.85 1.504 19.675 0.916504 18.5 0.916504C16.3458 0.916504 14.5833 2.679 14.5833 4.83317V5.42067C8.70833 7.18317 4.79167 12.4707 4.79167 18.5415V30.2915L0.875 34.2082V36.1665H36.125V34.2082L32.2083 30.2915ZM14.5833 38.1248C14.5833 40.279 16.3458 42.0415 18.5 42.0415C20.6542 42.0415 22.4167 40.279 22.4167 38.1248H14.5833ZM36.125 9.729C36.125 13.4498 32.9917 16.5832 29.2708 16.5832C25.55 16.5832 22.4167 13.4498 22.4167 9.729C22.4167 6.00817 25.55 2.87484 29.2708 2.87484C32.9917 2.87484 36.125 6.00817 36.125 9.729Z",
    fill: "#FEFFFE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThree);
export default __webpack_public_path__ + "static/media/three.ab11d27551c92a2147da2ef6e744320a.svg";
export { ForwardRef as ReactComponent };